import { Identifier } from '../../../../SeedingCalculator';
import { DanishSeedingCalculatorV1 } from './DanishSeedingCalculatorV1';
import { SeedingCalculatorStrategy } from './SeedingCalculatorStrategy';
import type { PrescriptionJob } from '../../../../PrescriptionJob';

const versionsByIdentifier: Record<Identifier, number[]> = {
  [Identifier.DANISH_SEEDING_MODEL]: [1],
};

export const getSeedingCalculatorStrategy = (
  identifier: Identifier,
  version: number
): SeedingCalculatorStrategy => {
  if (identifier === Identifier.DANISH_SEEDING_MODEL && version === 1) {
    return new DanishSeedingCalculatorV1();
  }

  throw new Error(`Unknown seeding calculator: ${identifier} v${version}`);
};

export const getLatestSeedingCalculatorStrategy = (
  identifier: Identifier
): SeedingCalculatorStrategy => {
  const versions = versionsByIdentifier[identifier];
  if (!versions?.length) {
    throw new Error(`Unknown seeding calculator identifier: ${identifier}`);
  }

  return getSeedingCalculatorStrategy(identifier, Math.max(...versions));
};

export const getSeedingCalculatorStrategyForJob = (
  prescriptionJob: PrescriptionJob | null,
  identifier: Identifier
): SeedingCalculatorStrategy => {
  const savedParams = prescriptionJob?.seedingCalculatorParams;
  if (savedParams) {
    return getSeedingCalculatorStrategy(savedParams.identifier, savedParams.version);
  }

  return getLatestSeedingCalculatorStrategy(identifier);
};
